import { render, staticRenderFns } from "./SortableTagInput.vue?vue&type=template&id=0a64a5c4&"
import script from "./SortableTagInput.vue?vue&type=script&lang=js&"
export * from "./SortableTagInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports